import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { PhoneNumberPriceInterface } from '../../store/callrecorder/phoneNumberPricesSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: callrecorderUrls.phoneNumberPricePath(value.id)
  };
}

export const phoneNumberPricesEntity = new schema.Entity(
  'phone_number_prices',
  {},
  {
    processStrategy
  }
);

export const phoneNumberPriceEntity = new schema.Entity(
  'phone_number_price',
  {},
  {
    processStrategy
  }
);

const fetchPhoneNumberPricesCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      phone_number_prices: { [key: string]: PhoneNumberPriceInterface };
    }
  >(response.data.phone_number_prices, [phoneNumberPricesEntity]);

  return {
    phoneNumberPrices: normalized.entities?.phone_number_prices || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { phone_number_price: PhoneNumberPriceInterface; }
  >(response.data.phone_number_price, phoneNumberPriceEntity);
  return normalized.entities;
}

export const fetchPhoneNumberPrices = createAsyncThunk(
  `${PREFIX}_phone_number_prices/fetchPhoneNumberPrices`,
  async (params: object = {}) => fetchPhoneNumberPricesCollection('/onesky/phone_number_prices', params)
);

export const fetchPhoneNumberPrice = createAsyncThunk(
  `${PREFIX}_phone_number_prices/fetchPhoneNumberPrice`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/phone_number_prices/${id}`);
    return normalizeInstance(response);
  }
);

export const updatePhoneNumberPrice = createAsyncThunk(
  `${PREFIX}_phone_number_prices/updatePhoneNumberPrice`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await callrecorderApi.patch(`/onesky/phone_number_prices/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
